import { render, staticRenderFns } from "./ReportSelectReasonPage.vue?vue&type=template&id=12350317&scoped=true"
import script from "./ReportSelectReasonPage.vue?vue&type=script&lang=js"
export * from "./ReportSelectReasonPage.vue?vue&type=script&lang=js"
import style0 from "./ReportSelectReasonPage.vue?vue&type=style&index=0&id=12350317&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12350317",
  null
  
)

export default component.exports